import { z } from "zod";

export const SignupFormSchema = z.object({
  firstName: z
    .string()
    .min(2, { message: "Name must be at least 2 characters long." })
    .trim(),
  lastName: z
    .string()
    .trim().optional(),
  email: z.string().email({ message: "Please enter a valid email." }).trim(),
  password: z
    .string()
    .min(7, { message: "Be at least 7 characters long" })
    // .regex(/[a-zA-Z]/, { message: "Contain at least one letter." })
    // .regex(/[0-9]/, { message: "Contain at least one number." })
    .trim(),
});
export type UpdateUserFormState = z.infer<typeof UpdateUserSchema>;
export const UpdateUserSchema = z.object({
  firstName: z
    .string()
    .min(2, { message: "Name must be at least 2 characters long." })
    .trim(),
  lastName: z.string().trim(),
  email: z.string().email({ message: "Please enter a valid email." }).trim(),
});

export type UpdatePasswordFormState = z.infer<typeof UpdatePasswordSchema>;
export const UpdatePasswordSchema = z.object({
  newPassword: z
    .string()
    .min(7, { message: "Be at least 7 characters long" })
    // .regex(/[a-zA-Z]/, { message: "Contain at least one letter." })
    // .regex(/[0-9]/, { message: "Contain at least one number." })
    // .regex(/[^a-zA-Z0-9]/, {
    //   message: "Contain at least one special character.",
    // })
    .trim(),
});

export const LoginFormSchema = z.object({
  email: z.string().email({ message: "Please enter a valid email." }),
  password: z.string().min(7, { message: "Be at least 7 characters long" })
});

export type FormState =
  | { error: string }
  | {
      errors?: {
        firstName?: string[];
        lastName?: string[];
        email?: string[];
        password?: string[];
      };
      message?: string;
    }
  | undefined;

export type SessionPayload = {
  userId: string | number;
  firstName: string;
  lastName: string;
  email: string;
  accessToken: string;
  refreshToken: string;
};
